import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import {CardTitle, CardText, ListGroup, ListGroupItem} from 'reactstrap';
import renderExplanation from './Explanation';


const FileTask = ({title, description, files, showCorrect, explanation}) => {
    return <>
        <CardTitle>{title}</CardTitle>
        <CardText dangerouslySetInnerHTML={{ __html: description }} />
        <ListGroup>
            { files.map(({label, path}, index) =>
                <ListGroupItem key={index} tag="a" href={path} download={label}>
                    <FontAwesomeIcon size="sm" icon={faDownload}/> {label}
                </ListGroupItem>
            )}
        </ListGroup>
        {(showCorrect && explanation)? renderExplanation(explanation) : undefined}
    </>
}

export default FileTask;